import { Typography } from "@material-ui/core";

export const getProviderOptions = () => {
  return ["MITEK", "NONE"].map((item) => {
    return {
      value: item,
      text: item,
    };
  });
};

export const getEnvironmentOptions = () => {
  return ["live", "sandbox"].map((item) => {
    return {
      value: item,
      text: item,
    };
  });
};

export const getDocumentOptions = () => {
  return [
    "liveness",
    "passport",
    "id",
    "driving",
    "visa",
    "residence",
    "passcard",
    "bill",
    "bank",
    "tax",
    "insurance",
    "address",
  ].map((item) => {
    return {
      value: item,
      component: <Typography style={{ margin: 0 }}>{item}</Typography>,
    };
  });
};
